<!--
 * @Author: zhaozhuo
 * @Date: 2021-12-16 10:28:22
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-04-01 17:22:30
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\utilsComponents\dialog\index.vue
-->
<template>
  <div class="main-dialog">
    <div class="main-dialog-text">
      <div class="main-dialog-content">
        {{ content }}
      </div>
    </div>
    <div class="main-dialog-button">
      <div class="cancel" @click="cancel">
        取消
      </div>
      <div class="finish" @click="finish">
        确认
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: false
		},
		// 弹窗内容
		content: {
			type: String,
			default: ''
		},
		// 要删除重复组index
		index: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
		}
	},
	methods: {
		// 关闭弹框
		cancel() {
			this.$emit('cancelDialog')
		},
		// 弹框确认
		finish() {
			this.$emit('finishDialog', this.index)
		}
	}
}
</script>
